import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { createInteraction } from '~/pages/pay/utils/customerInteraction';
import { api } from '~/shared/lib/api';
import { PageLayout } from '~/shared/ui/PageLayout/PageLayout';
import { Spinner } from '~/shared/ui/Spinner/Spinner';

import { Root } from './RedirectPage.ui';

export const RedirectPage = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const sessionId = searchParams.get('sessionId');
    const hash = searchParams.get('hash');

    if (!sessionId || !hash) {
      console.error('Отсутствуют обязательные параметры sessionId или hash');
      return;
    }

    const performRedirect = async () => {
      try {
        const { data } = await api.get(`/api/session/${sessionId}/${hash}`);

        const {
          payment: { customerInteraction },
        } = data;

        createInteraction(customerInteraction);
      } catch (error) {
        console.error('Ошибка при получении данных сессии:', error);
      }
    };

    performRedirect();
  }, [searchParams]);

  return (
    <PageLayout>
      <Root>
        <Spinner size={48} />
      </Root>
    </PageLayout>
  );
};
